var _circle, _path, _rect;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgDiscoverActive = function SvgDiscoverActive(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 9.833,
    cy: 9.834,
    r: 7.542,
    transform: "rotate(-45 9.833 9.834)",
    fill: "#fff",
    fillOpacity: 0.24
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.833 3.833a8.485 8.485 0 0 0 11.297 12.63l3.037 3.037 1.333-1.333-3.037-3.037A8.486 8.486 0 0 0 3.833 3.833Zm1.334 1.334A6.6 6.6 0 1 1 14.5 14.5a6.6 6.6 0 0 1-9.333-9.333Z",
    fill: "#D1B896"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 16.5,
    y: 19.834,
    width: 4.714,
    height: 8.485,
    rx: 2.357,
    transform: "rotate(-45 16.5 19.834)",
    fill: "#A79378"
  })));
};
export default SvgDiscoverActive;